const INITIAL_STATE = {
    multiCurrencyEnabled: false,
    selectedCurrency: null,
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {

        case 'SET_MULTI_CURRENCY_ENABLED':
            return {
                ...state,
                multiCurrencyEnabled: action.multiCurrencyEnabled
            }

        case 'SET_SELECTED_CURRENCY':
            return { ...state,
                selectedCurrency: action.selectedCurrency,
            }

        default:
            return state;
    }
}